export enum ROLES {
  SUPER_ADMIN = "SUPER_ADMIN",
  HOST = "HOST",
  AMBASSADOR = "AMBASSADOR",
  ATTENDEE = "ATTENDEE",
  CHILD = "CHILD",
  RSVP = "RSVP",
  User = "user",
  Admin = "admin",
}

export enum LEADER_ROLES {
  HOST = "HOST",
  AMBASSADOR = "AMBASSADOR",
  ATTENDEE = "ATTENDEE",
}

export enum TEAM_MEMBER_ROLES {
  MANAGER = "MANAGER",
  AMBASSADOR = "AMBASSADOR",
  CEO = "CEO",
  COO = "COO",
  TRAINER = "TRAINER",
  SUB_ADMIN = "SUB_ADMIN",
}

export enum BADGE_TYPE {
  EVENT = "event",
  ACHIEVEMENT = "achievement",
  CORE_CONCEPT = "core_concept",
}

export enum ORDER_STATUS {
  PENDING = "pending",
  DISPATCHED = "dispatched",
}
